import { RESET_STUDIO_ACTION } from '../consts';
import type { StudioHostingActions } from '../../actions/studio/hosting';
import type AppError from '../../lib/AppError';

export interface State {
    isToggling: boolean;
    toggleHostingError: AppError | null;
}

const getDefaultState = (): State => ({
    isToggling: false,
    toggleHostingError: null
});

const hostingReducer = (state = getDefaultState(), action: StudioHostingActions | null): State => {
    switch (action?.type) {
        case 'SET_HOSTING_STARTED': {
            return {
                ...state,
                isToggling: true,
                toggleHostingError: null
            };
        }

        case 'SET_HOSTING_DONE': {
            return {
                ...state,
                isToggling: false
            };
        }

        case 'SET_HOSTING_FAILED': {
            return {
                ...state,
                toggleHostingError: action.data.error,
                isToggling: false
            };
        }

        case RESET_STUDIO_ACTION: {
            return getDefaultState();
        }

        default: {
            return state;
        }
    }
};

export default hostingReducer;
